import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "../styles/styles.module.css";

export const Heading = ({
  children,
  domElement,
  sizing,
  className,
  isUppercase,
  ...props
}) => {
  const Component = domElement;

  return (
    <Component
      className={classnames(sizing, styles.typographyHeader, className, {
        [styles.typographyHeaderUppercase]: isUppercase,
      })}
      {...props}
      data-testid="heading"
    >
      {children}
    </Component>
  );
};

Heading.displayName = "Heading";

Heading.propTypes = {
  children: PropTypes.node,
  domElement: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]).isRequired,
  sizing: PropTypes.string.isRequired,
  className: PropTypes.string,
  isUppercase: PropTypes.bool,
};

Heading.defaultProps = {
  domElement: "h1",
  sizing: "barnsley1",
  isUppercase: false,
};
